var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tag)?_c('div',{staticClass:"is-padded",attrs:{"id":"tag-show"}},[_c('Section',{attrs:{"title":"Meta","open":""}},[_c('LabelLineValue',{attrs:{"label":"Name","value":_vm.tag.name,"clickToCopy":""}}),_c('LabelLineValue',{attrs:{"label":"Color","value":_vm.tag.color,"clickToCopy":""}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }